import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';
import { SearchResultToggle } from '@/features/product-listing/ui/molecules/search-result-toggle';
import type { PlpFiltersState } from '../../../hooks/use-plp-filters';
import { useInStockFilter } from '../../../hooks/use-in-stock-filter';
import { AppliedFilters } from '../../molecules';
import { FilterPanel } from '../filter-panel';

export interface FilterSidebarProps {
    filters: PlpFiltersState;
    inStockSwitchEnabled: boolean;
    className?: string;
}

export const FilterSidebar = ({ filters, inStockSwitchEnabled, className }: FilterSidebarProps) => {
    const { t } = useTranslation('plpFilters');
    const inStock = useInStockFilter(filters);

    return (
        <aside
            data-slot="filter-sidebar"
            aria-label={t('filters')}
            className={cn(
                'flex flex-col py-4',
                filters.appliedFilters.length > 0 ? 'gap-4' : 'gap-2',
                filters.isPending && 'pointer-events-none opacity-60 transition-opacity',
                className
            )}>
            <SearchResultToggle
                itemCount={filters.total}
                checked={inStock.enabled}
                onCheckedChange={inStock.setEnabled}
                showToggle={inStockSwitchEnabled}
                textLabel={t('inStockOnly')}
                countLabel={t('results', { count: filters.total })}
            />
            <AppliedFilters filters={filters.appliedFilters} onRemove={filters.remove} onClearAll={filters.clearAll} />
            <FilterPanel filters={filters} />
        </aside>
    );
};
